// extracted by mini-css-extract-plugin
export default {"container":"U2Xk"};